import { createTheme } from '@mui/material/styles';

const { palette } = createTheme();

const shadows: [
  'none',
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
  string,
] = [
  'none', // elevation 0

  '0 1px 2px rgba(0, 0, 0, 0.05)',
  '0 1px 3px rgba(0, 0, 0, 0.08)',
  '0 2px 4px rgba(0, 0, 0, 0.08)',
  '0 2px 6px rgba(0, 0, 0, 0.1)',
  '0 3px 8px rgba(0, 0, 0, 0.12)',

  '0 4px 10px rgba(0, 0, 0, 0.12)',
  '0 5px 12px rgba(0, 0, 0, 0.14)',
  '0 6px 14px rgba(0, 0, 0, 0.15)',
  '0 7px 16px rgba(0, 0, 0, 0.16)',

  '0 8px 18px rgba(0, 0, 0, 0.18)',
  '0 10px 20px rgba(0, 0, 0, 0.18)',
  '0 12px 24px rgba(0, 0, 0, 0.2)',
  '0 14px 28px rgba(0, 0, 0, 0.22)',

  '0 16px 32px rgba(0, 0, 0, 0.24)',
  '0 18px 36px rgba(0, 0, 0, 0.26)',
  '0 20px 40px rgba(0, 0, 0, 0.28)',
  '0 22px 44px rgba(0, 0, 0, 0.3)',

  '0 24px 48px rgba(0, 0, 0, 0.32)',
  '0 26px 52px rgba(0, 0, 0, 0.34)',
  '0 28px 56px rgba(0, 0, 0, 0.36)',
  '0 30px 60px rgba(0, 0, 0, 0.38)',

  '0 32px 64px rgba(0, 0, 0, 0.4)',
  '0 34px 68px rgba(0, 0, 0, 0.42)',
  '0 40px 72px rgba(0, 0, 0, 0.44)',
];

export const theme = createTheme({
  palette: {
    primary: palette.augmentColor({
      color: {
        main: '#151515',
      },
    }),
    secondary: {
      main: '#fc0841',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFC107',
      contrastText: '#ffffff',
    },
    success: {
      main: '#4CAF50',
      contrastText: '#ffffff',
    },
    info: {
      main: '#2196F3',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FF5722',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  shadows,
  components: {
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: '#fc0841',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)', // Hover state
          },
          '&[aria-selected="true"]': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)', // Selected state
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.12)', // Selected + hover state
            },
          },
          '&.Mui-focused': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)', // Focused state (keyboard navigation)
          },
        },
      },
    },
  },
});
